(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-stamp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-parallax]').forEach(function (section) {
      if (reduced || section.dataset.parallaxInit) return;
      section.dataset.parallaxInit = 'true';

      var image = section.querySelector('.stamp__media-image');
      var strength = Number(section.dataset.parallax) / 100;
      var ticking = false;

      function update() {
        ticking = false;
        var rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
        image.style.setProperty('--stamp-shift', (progress * strength * rect.height * -1).toFixed(1) + 'px');
      }
      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class CartDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');

          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-close]')) this.close();
            if (event.target === this.dialog) this.close();

            const qtyButton = event.target.closest('[data-qty-change]');
            if (qtyButton) {
              const input = this.querySelector(
                `[data-qty-input][data-key="${qtyButton.dataset.key}"]`
              );
              const quantity =
                Number(input.value) + Number(qtyButton.dataset.qtyChange);
              this.changeQuantity(qtyButton.dataset.key, Math.max(0, quantity));
            }

            const removeButton = event.target.closest('[data-remove]');
            if (removeButton) {
              this.changeQuantity(removeButton.dataset.key, 0);
            }
          });

          this.addEventListener('change', (event) => {
            const input = event.target.closest('[data-qty-input]');
            if (input) {
              this.changeQuantity(input.dataset.key, Math.max(0, Number(input.value)));
            }
          });

          if (!window.goldCartDrawerInit) {
            window.goldCartDrawerInit = true;

            document.addEventListener('click', (event) => {
              const toggle = event.target.closest('[data-cart-toggle]');
              if (!toggle) return;
              event.preventDefault();
              document.querySelector('cart-drawer').open();
            });

            document.addEventListener('submit', (event) => {
              const form = event.target;
              const drawer = document.querySelector('cart-drawer');
              if (!drawer) return;
              if (!form.action || !form.action.includes('/cart/add')) return;
              event.preventDefault();
              drawer.addToCart(form);
            }, true); // Prevent native form tracking before Shopify's AJAX cart event.
          }
        }

        open() {
          if (!this.dialog.open) this.dialog.showModal();
        }

        close() {
          this.dialog.close();
        }

        showError(message, form) {
          let output = form ? form.querySelector('[data-cart-error]') : this.querySelector('[data-cart-error]');
          if (!output && form) {
            output = document.createElement('p');
            output.className = 'le-cart-error';
            output.dataset.cartError = '';
            output.setAttribute('role', 'alert');
            form.append(output);
          }
          if (output) { output.textContent = message; output.hidden = !message; }
        }

        stockLimitMessage(max) {
          return this.dataset.stockLimitMessage.split('%count%').join(max);
        }

        async addToCart(form) {
          if (this.pending) return;
          this.pending = true;
          const button = form.querySelector('[type="submit"]');
          if (button) button.disabled = true;
          this.showError('', form);
          let added = false;
          try {
            const idInput = form.querySelector('input[name="id"]');
            const stockMax = idInput?.dataset.stockMax;
            if (stockMax !== undefined) {
              const max = Number(stockMax);
              const requested = Number(new FormData(form).get('quantity') || 1);
              const cartResponse = await fetch(`${this.dataset.rootUrl}cart.js`);
              if (!cartResponse.ok) throw new Error(this.dataset.errorMessage);
              const cart = await cartResponse.json();
              const inCart = cart.items
                .filter((item) => String(item.variant_id) === idInput.value)
                .reduce((total, item) => total + item.quantity, 0);
              if (inCart + requested > max) throw new Error(this.stockLimitMessage(max));
            }
            const response = await fetch(`${this.dataset.addUrl}.js`, {
              method: 'POST', body: new FormData(form),
            });
            if (!response.ok) {
              const error = await response.json().catch(() => ({}));
              throw new Error(error.description || this.dataset.errorMessage);
            }
            added = true;
            await this.refresh();
            this.open();
          } catch (error) {
            // Never resubmit a successful or uncertain POST. Show the canonical cart
            // after a rendering failure; let the user retry a rejected add explicitly.
            if (added) window.location.assign(`${this.dataset.rootUrl}cart`);
            else this.showError(error.message || this.dataset.errorMessage, form);
          } finally {
            this.pending = false;
            if (button) button.disabled = false;
          }
        }

        async changeQuantity(key, quantity) {
          if (this.pending || !Number.isInteger(quantity) || quantity < 0) return;
          const item = [...this.querySelectorAll('.cart-drawer__item')]
            .find((entry) => entry.querySelector('[data-key]')?.dataset.key === key);
          const stockMax = item?.dataset.stockMax;
          if (stockMax !== undefined && quantity > Number(stockMax)) {
            this.showError(this.stockLimitMessage(stockMax));
            return;
          }
          this.pending = true;
          this.showError('');
          const controls = [...this.querySelectorAll('[data-qty-change], [data-qty-input], [data-remove]')];
          controls.forEach(control => control.disabled = true);
          try {
            const response = await fetch(`${this.dataset.changeUrl}.js`, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity }),
            });
            if (!response.ok) {
              const error = await response.json().catch(() => ({}));
              throw new Error(error.description || this.dataset.errorMessage);
            }
            await this.refresh();
          } catch (error) {
            this.showError(error.message || this.dataset.errorMessage);
          } finally {
            this.pending = false;
            controls.forEach(control => {
              if (control.dataset.qtyChange === '1') {
                const row = control.closest('.cart-drawer__item');
                const max = row?.dataset.stockMax;
                const current = Number(row?.querySelector('[data-qty-input]')?.value);
                control.disabled = max !== undefined && current >= Number(max);
              } else control.disabled = false;
            });
          }
        }

        async refresh() {
          const response = await fetch(
            `${this.dataset.rootUrl}?section_id=cart-drawer`
          );
          if (!response.ok) throw new Error(this.dataset.errorMessage);
          const html = await response.text();
          const incoming = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('cart-drawer');
          if (!incoming) throw new Error(this.dataset.errorMessage);

          const wasOpen = this.dialog.open;
          this.dataset.itemCount = incoming.dataset.itemCount;
          this.dialog.innerHTML = incoming.querySelector('dialog').innerHTML;
          if (wasOpen && !this.dialog.open) this.dialog.showModal();
          this.updateHeaderCount();
        }

        updateHeaderCount() {
          const count = Number(this.dataset.itemCount);
          const cartLink = document.querySelector('[data-cart-toggle]');
          if (!cartLink) return;
          let badge = cartLink.querySelector('.header__cart-count');
          if (count === 0) {
            if (badge) badge.remove();
            return;
          }
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            cartLink.append(badge);
          }
          badge.textContent = count;
        }
      }
    );
  }

  if (!customElements.get('count-down')) {
    customElements.define(
      'count-down',
      class CountDown extends HTMLElement {
        connectedCallback() {
          this.output = this.querySelector('[data-countdown-time]');
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          if (!this.output) return;
          const now = new Date();
          const cutoff = new Date(now);
          cutoff.setHours(Number(this.dataset.hour), 0, 0, 0);
          if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);

          const total = Math.floor((cutoff - now) / 1000);
          const hours = Math.floor(total / 3600);
          const minutes = Math.floor((total % 3600) / 60);
          const seconds = total % 60;
          this.output.textContent = [hours, minutes, seconds]
            .map((part) => String(part).padStart(2, '0'))
            .join(':');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Load more: fetches the next paginated page and appends its cards. The
  // numbered links stay in the markup and only get hidden once this runs, so
  // the collection still works end to end without JavaScript.
  if (!window.goldLoadMoreInit) {
    window.goldLoadMoreInit = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-load-more]');
      if (!button) return;

      var url = button.dataset.url;
      if (!url || button.dataset.busy) return;

      var grid = document.querySelector('[data-product-grid]');
      if (!grid) return;

      button.dataset.busy = '1';
      var label = button.textContent;
      button.textContent = button.dataset.loadingLabel || label;

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-product-grid]');
          if (next) {
            Array.prototype.forEach.call(next.children, function (card) {
              grid.appendChild(document.importNode(card, true));
            });
          }

          var nextButton = doc.querySelector('[data-load-more]');
          if (nextButton && nextButton.dataset.url) {
            button.dataset.url = nextButton.dataset.url;
            button.textContent = label;
          } else {
            button.remove();
          }

          // The fetched page reports its own page size, not the running
          // total, so count what is actually on screen.
          var count = document.querySelector('[data-count]');
          if (count) {
            count.textContent = (count.dataset.template || '')
              .replace('[shown]', grid.querySelectorAll('.product-card').length)
              .replace('[total]', count.dataset.total);
          }

          // Keep the address bar on the last page loaded, so a refresh or a
          // shared link lands somewhere sensible.
          try { history.replaceState({}, '', url); } catch (err) {}
        })
        .catch(function () {
          button.textContent = label;
        })
        .finally(function () {
          delete button.dataset.busy;
        });
    });

    // Only hide the numbered links once we know the button can work.
    document.querySelectorAll('[data-load-more]').forEach(function (button) {
      var section = button.closest('.shopify-section') || document.body;
      section.classList.add('collection--enhanced');
    });
  }

  if (!window.goldFiltersInit) {
    window.goldFiltersInit = true;

    document.addEventListener('change', (event) => {
      const form = event.target.closest('[data-filter-form]');
      if (!form) return;
      if (event.target.type === 'number') return;
      form.submit();
    });

    document.addEventListener('click', (event) => {
      document
        .querySelectorAll('.collection-filter[open]')
        .forEach((dropdown) => {
          if (!dropdown.contains(event.target)) {
            dropdown.removeAttribute('open');
          }
        });

      const viewBtn = event.target.closest('.collection-view__btn');
      if (viewBtn) {
        const grid = document.querySelector('[data-product-grid]');
        if (grid) grid.style.setProperty('--grid-columns-desktop', viewBtn.dataset.cols);
        viewBtn
          .closest('[data-view-toggle]')
          .querySelectorAll('.collection-view__btn')
          .forEach((b) => b.classList.toggle('is-active', b === viewBtn));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"]) return;
  try {
    
  (function () {
    var KEY = 'gold:consent';
    var banner = document.querySelector('[data-cookie-banner]');
    var prefs = document.querySelector('[data-cookie-prefs]');
    if (!banner) return;

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; }
    }

    function gtagPush() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(arguments);
    }

    function applyConsent(c) {
      // 1. Persist
      try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}

      // 2. Google Consent Mode v2 update (GA4 / GTM ready)
      var g = function (v) { return v ? 'granted' : 'denied'; };
      gtagPush('consent', 'update', {
        ad_storage: g(c.marketing),
        ad_user_data: g(c.marketing),
        ad_personalization: g(c.marketing),
        analytics_storage: g(c.analytics),
        personalization_storage: g(c.preferences),
        functionality_storage: 'granted',
        security_storage: 'granted'
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'cookie_consent_update', consent: c });

      // 3. Shopify Customer Privacy API so Shopify + pixels honor it
      function setShopifyConsent() {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: c.analytics,
              marketing: c.marketing,
              preferences: c.preferences,
              sale_of_data: c.marketing
            },
            function () {}
          );
        } catch (e) {}
      }
      if (window.Shopify && window.Shopify.customerPrivacy) {
        setShopifyConsent();
      } else if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) { if (!error) setShopifyConsent(); }
        );
      }

      // 4. Hide UI
      banner.hidden = true;
      if (prefs && prefs.open) prefs.close();
    }

    // Show banner only when no choice stored
    var stored = read();
    if (!stored) {
      banner.hidden = false;
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cookie-accept]')) {
        applyConsent({ analytics: true, marketing: true, preferences: true });
      } else if (e.target.closest('[data-cookie-decline]')) {
        applyConsent({ analytics: false, marketing: false, preferences: false });
      } else if (e.target.closest('[data-cookie-prefs-open]')) {
        if (prefs) {
          var current = read() || {};
          prefs.querySelectorAll('[data-consent-cat]').forEach(function (input) {
            input.checked = !!current[input.dataset.consentCat];
          });
          prefs.showModal();
        }
      } else if (e.target.closest('[data-cookie-prefs-close]')) {
        if (prefs) prefs.close();
      } else if (e.target.closest('[data-cookie-save]')) {
        var c = { analytics: false, marketing: false, preferences: false };
        prefs.querySelectorAll('[data-consent-cat]').forEach(function (input) {
          c[input.dataset.consentCat] = input.checked;
        });
        applyConsent(c);
      } else if (prefs && e.target === prefs) {
        prefs.close();
      }
    });

    // Re-open the preferences from anywhere (e.g. a footer link with
    // href="#cookie-voorkeuren")
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="#cookie-voorkeuren"], a[href="#cookie-preferences"]');
      if (!link || !prefs) return;
      e.preventDefault();
      var current = read() || {};
      prefs.querySelectorAll('[data-consent-cat]').forEach(function (input) {
        input.checked = !!current[input.dataset.consentCat];
      });
      prefs.showModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  if (!customElements.get('address-form')) {
    customElements.define(
      'address-form',
      class AddressForm extends HTMLElement {
        connectedCallback() {
          this.country = this.querySelector('[name="address[country]"]');
          this.province = this.querySelector('[name="address[province]"]');
          this.provinceWrapper = this.querySelector('[data-province-wrapper]');
          if (!this.country || !this.province) return;

          if (this.country.dataset.default) {
            this.country.value = this.country.dataset.default;
          }
          this.country.addEventListener('change', () => this.updateProvinces());
          this.updateProvinces(true);
        }

        updateProvinces(initial = false) {
          const option = this.country.selectedOptions[0];
          const provinces = JSON.parse(
            (option && option.dataset.provinces) || '[]'
          );
          this.province.replaceChildren();

          if (!provinces.length) {
            this.provinceWrapper.hidden = true;
            return;
          }

          this.provinceWrapper.hidden = false;
          for (const province of provinces) {
            const el = document.createElement('option');
            el.value = province[0];
            el.textContent = province[1];
            if (initial && province[0] === this.province.dataset.default) {
              el.selected = true;
            }
            this.province.append(el);
          }
        }
      }
    );

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-confirm]');
      if (form && !window.confirm(form.dataset.confirm)) {
        event.preventDefault();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!window.goldFooterInit) {
    window.goldFooterInit = true;
    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-locale-select]');
      if (select) select.form.submit();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('predictive-search')) {
    customElements.define(
      'predictive-search',
      class PredictiveSearch extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-search-input]');
          this.results = this.querySelector('[data-results]');
          this.panel = this.querySelector('[data-panel]');
          this.empty = this.querySelector('[data-empty]');
          this.clearBtn = this.querySelector('[data-search-clear]');
          if (!this.input) return;

          this.input.addEventListener('input', () => {
            this.toggleClear();
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => this.search(), 250);
          });
          this.input.addEventListener('focus', () => {
            this.open();
            this.toggleClear();
          });
          this.input.addEventListener('blur', () => this.toggleClear());

          if (this.clearBtn) {
            // keep focus when pressing the clear icon so the click fires
            this.clearBtn.addEventListener('mousedown', (event) => event.preventDefault());
            this.clearBtn.addEventListener('click', () => {
              this.input.value = '';
              this.input.blur();
              this.close();
              this.toggleClear();
            });
          }

          if (this.panel) {
            document.addEventListener('click', (event) => {
              if (!this.contains(event.target)) this.close();
            });
            document.addEventListener('keydown', (event) => {
              if (event.key === 'Escape') this.close();
            });
          }

          this.startTypewriter();
        }

        open() {
          if (!this.panel) return;
          const hasQuery = this.input.value.trim().length >= 2;
          const hasEmpty = this.empty && this.empty.querySelector('a');
          if (!hasQuery && !hasEmpty) return;
          const header = this.closest('.header');
          const bottom = header ? Math.floor(header.getBoundingClientRect().bottom) : 96;
          this.panel.style.setProperty('--panel-top', bottom + 'px');
          this.panel.hidden = false;
          this.toggleStates();
        }

        close() {
          if (this.panel) this.panel.hidden = true;
        }

        toggleStates() {
          const hasQuery = this.input.value.trim().length >= 2;
          if (this.empty) this.empty.hidden = hasQuery;
          if (this.results) this.results.hidden = !hasQuery;
        }

        toggleClear() {
          if (!this.clearBtn) return;
          // show the clear icon as soon as the field is focused (the
          // placeholder fades) or when there is text.
          const active = document.activeElement === this.input;
          this.clearBtn.hidden = !(active || this.input.value.length > 0);
        }

        async search() {
          const query = this.input.value.trim();
          if (query.length < 2) {
            if (this.results) this.results.replaceChildren();
            this.open();
            this.toggleStates();
            return;
          }
          const params = new URLSearchParams({
            q: query,
            'resources[type]': 'product,collection,query',
            'resources[limit]': '10',
            section_id: 'predictive-search',
          });
          const response = await fetch(`${this.dataset.url}?${params}`);
          const html = await response.text();
          const found = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('.psearch');
          this.results.replaceChildren(...(found ? [found] : []));
          this.open();
          this.toggleStates();
        }

        startTypewriter() {
          const phrases = (this.dataset.typewriter || '')
            .split('|')
            .map((s) => s.trim())
            .filter(Boolean);
          if (!phrases.length) return;
          const rawPrefix = this.dataset.searchPrefix || '';
          // Always one trailing space between the prefix and the word.
          const prefix = rawPrefix ? rawPrefix.replace(/\s*$/, '') + ' ' : '';
          let pi = 0;
          let ci = 0;
          let deleting = false;
          const tick = () => {
            if (this.input.value) {
              this.input.setAttribute('placeholder', prefix);
              return setTimeout(tick, 700);
            }
            const phrase = phrases[pi];
            ci += deleting ? -1 : 1;
            this.input.setAttribute('placeholder', prefix + phrase.slice(0, ci));
            if (!deleting && ci === phrase.length) {
              deleting = true;
              return setTimeout(tick, 1600);
            }
            if (deleting && ci === 0) {
              deleting = false;
              pi = (pi + 1) % phrases.length;
            }
            setTimeout(tick, deleting ? 45 : 95);
          };
          setTimeout(tick, 900);
        }
      }
    );
  }

  if (!window.goldHeaderInit) {
    window.goldHeaderInit = true;

    // The mobile menu panel hangs off the bottom of the header, which moves
    // with the announcement bar, the sticky state and the padding setting.
    const positionDrawer = () => {
      const drawer = document.querySelector('.header__drawer');
      const header = drawer && drawer.closest('.header');
      if (!header) return;
      const bottom = Math.floor(header.getBoundingClientRect().bottom);
      drawer.style.setProperty('--drawer-top', bottom + 'px');
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('.header__drawer > summary')) requestAnimationFrame(positionDrawer);
    });
    window.addEventListener('resize', positionDrawer);
    window.addEventListener('scroll', positionDrawer, { passive: true });
    positionDrawer();

    // Mega-menu: open on hover/focus, close on leave/Escape.
    const positionMega = (panel) => {
      const header = panel.closest('.header');
      const bottom = header ? Math.floor(header.getBoundingClientRect().bottom) : 96;
      panel.style.setProperty('--panel-top', bottom + 'px');

      // A compact dropdown hangs under the header too, not under its own
      // link, so both panels share one baseline. It keeps its horizontal
      // alignment with the menu item it belongs to.
      if (panel.classList.contains('header__dropdown')) {
        const item = panel.closest('.header__nav-item');
        if (item) {
          panel.style.setProperty('--panel-left', Math.round(item.getBoundingClientRect().left) + 'px');
        }
      }
    };
    // Keep fixed panels attached when the announcement bar scrolls away.
    let panelPositionFrame = 0;
    const schedulePanelPosition = () => {
      if (panelPositionFrame) return;
      panelPositionFrame = requestAnimationFrame(() => {
        panelPositionFrame = 0;
        document.querySelectorAll('[data-mega-panel]:not([hidden])').forEach(positionMega);
      });
    };
    window.addEventListener('scroll', schedulePanelPosition, { passive: true });
    window.addEventListener('resize', schedulePanelPosition);
    const headerSizeObserver = new ResizeObserver(schedulePanelPosition);
    document.querySelectorAll('.header').forEach((header) => headerSizeObserver.observe(header));

    document.querySelectorAll('[data-mega]').forEach((item) => {
      const panel = item.querySelector('[data-mega-panel]');
      const link = item.querySelector('.header__nav-link');
      if (!panel) return;
      let closeTimer;
      const open = () => {
        clearTimeout(closeTimer);
        document.querySelectorAll('[data-mega-panel]').forEach((p) => {
          if (p !== panel) p.hidden = true;
        });
        positionMega(panel);
        panel.hidden = false;
        if (link) link.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        panel.hidden = true;
        if (link) link.setAttribute('aria-expanded', 'false');
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(close, 120);
      });
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) close();
      });
      panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    });
    document.addEventListener('click', (event) => {
      const arrow = event.target.closest('[data-mega-scroll]');
      if (!arrow) return;
      const row = arrow.parentElement.querySelector('[data-mega-row]');
      if (!row) return;
      const card = row.firstElementChild;
      const gap = parseFloat(getComputedStyle(row).columnGap) || 16;
      const step = (card ? card.getBoundingClientRect().width + gap : row.clientWidth) * Number(arrow.dataset.megaScroll);
      const from = row.scrollLeft;
      row.style.scrollSnapType = 'none';
      row.scrollBy({ left: step, behavior: 'smooth' });
      setTimeout(() => {
        if (Math.abs(row.scrollLeft - from) < 2) row.scrollBy({ left: step, behavior: 'auto' });
      }, 300);
      setTimeout(() => {
        row.style.scrollSnapType = '';
      }, 800);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-mega-panel]').forEach((p) => (p.hidden = true));
    });

    document.addEventListener('click', (event) => {
      const searchToggle = event.target.closest('[data-search-toggle]');
      if (searchToggle) {
        event.preventDefault();
        const dialog = document.querySelector('.header__search');
        dialog.showModal();
        dialog.querySelector('[data-search-input]').focus();
        return;
      }
      if (event.target.closest('[data-search-close]')) {
        event.target.closest('dialog').close();
        return;
      }
      document
        .querySelectorAll('.header__submenu[open]')
        .forEach((submenu) => {
          if (!submenu.contains(event.target)) {
            submenu.removeAttribute('open');
          }
        });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document
        .querySelectorAll('.header__submenu[open], .header__drawer[open]')
        .forEach((menu) => menu.removeAttribute('open'));
    });

    let lastScrollY = window.scrollY;
    window.addEventListener(
      'scroll',
      () => {
        const header = document.querySelector('.header');
        if (!header) return;

        const y = window.scrollY;
        header.classList.toggle('header--scrolled', y > 24);

        if (header.classList.contains('header--sticky-scroll_up')) {
          const delta = y - lastScrollY;
          if (y < 100 || delta < -4) {
            header.classList.remove('header--hidden');
          } else if (delta > 4) {
            header.classList.add('header--hidden');
          }
        }
        lastScrollY = y;
      },
      { passive: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-wall"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-heritage]').forEach(function (section) {
    if (section.dataset.heritageInit) return;
    section.dataset.heritageInit = 'true';
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    section.classList.add('heritage--armed');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('heritage--in');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.goldSplitHeroInit) return;
    window.goldSplitHeroInit = true;

    document.querySelectorAll('[data-split-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-split-slide]');
      var dots = hero.querySelectorAll('[data-split-dot]');
      var interval = parseInt(hero.dataset.interval, 10) || 6000;
      var index = 0;
      var timer;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }
      function play() {
        clearInterval(timer);
        timer = setInterval(function () { show(index + 1); }, interval);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(parseInt(dot.dataset.splitDot, 10));
          play();
        });
      });

      // Pause while off-screen so a hero below the fold isn't cycling
      // through slides nobody is looking at.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries[0].isIntersecting ? play() : clearInterval(timer);
        }).observe(hero);
      } else {
        play();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-video')) {
    customElements.define(
      'hero-video',
      class HeroVideo extends HTMLElement {
        connectedCallback() {
          const url = this.dataset.url || '';
          const youtube = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
          const vimeo = url.match(/vimeo\.com\/(\d+)/);
          let src = null;
          if (youtube) {
            const id = youtube[1];
            src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&showinfo=0&modestbranding=1&rel=0&playsinline=1`;
          } else if (vimeo) {
            src = `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1&muted=1&loop=1&background=1`;
          }
          if (!src) return;
          const iframe = document.createElement('iframe');
          iframe.className = 'hero__video-frame';
          iframe.src = src;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.setAttribute('tabindex', '-1');
          iframe.setAttribute('aria-hidden', 'true');
          this.appendChild(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-video')) {
    customElements.define(
      'banner-video',
      class BannerVideo extends HTMLElement {
        connectedCallback() {
          const url = this.dataset.url || '';
          const youtube = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
          const vimeo = url.match(/vimeo\.com\/(\d+)/);
          let src = null;
          if (youtube) {
            const id = youtube[1];
            src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&showinfo=0&modestbranding=1&rel=0&playsinline=1`;
          } else if (vimeo) {
            src = `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1&muted=1&loop=1&background=1`;
          }
          if (!src) return;
          const iframe = document.createElement('iframe');
          iframe.className = 'image-banner__media-frame';
          iframe.src = src;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.setAttribute('tabindex', '-1');
          iframe.setAttribute('aria-hidden', 'true');
          this.appendChild(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bg-video')) {
    customElements.define(
      'bg-video',
      class BgVideo extends HTMLElement {
        connectedCallback() {
          const url = this.dataset.url || '';
          const youtube = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
          const vimeo = url.match(/vimeo\.com\/(\d+)/);
          let src = null;
          if (youtube) {
            const id = youtube[1];
            src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&showinfo=0&modestbranding=1&rel=0&playsinline=1`;
          } else if (vimeo) {
            src = `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1&muted=1&loop=1&background=1`;
          }
          if (!src) return;
          const iframe = document.createElement('iframe');
          iframe.className = 'image-with-text__video-frame';
          iframe.src = src;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.setAttribute('tabindex', '-1');
          iframe.setAttribute('aria-hidden', 'true');
          this.appendChild(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-club"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.goldOrbitInit) return;
    window.goldOrbitInit = true;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function track(section) {
      var spread = parseFloat(getComputedStyle(section).getPropertyValue('--orbit-spread')) || 0;
      var ticking = false;

      function update() {
        var rect = section.getBoundingClientRect();
        var height = rect.height || window.innerHeight;
        var progress = Math.max(0, Math.min(1, -rect.top / height));
        section.style.setProperty('--scroll-progress', progress.toFixed(4));
        section.style.setProperty('--orbit-expand', (progress * spread).toFixed(3) + 'rem');
        ticking = false;
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    function init() {
      if (reduced.matches) return;
      document.querySelectorAll('[data-orbit]').forEach(track);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  // Background video (YouTube/Vimeo)
  if (!customElements.get('pw-video')) {
    customElements.define(
      'pw-video',
      class PwVideo extends HTMLElement {
        connectedCallback() {
          const url = this.dataset.url || '';
          const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
          const vm = url.match(/vimeo\.com\/(\d+)/);
          let src = null;
          if (yt) {
            src = `https://www.youtube-nocookie.com/embed/${yt[1]}?autoplay=1&mute=1&loop=1&playlist=${yt[1]}&controls=0&showinfo=0&modestbranding=1&rel=0&playsinline=1`;
          } else if (vm) {
            src = `https://player.vimeo.com/video/${vm[1]}?autoplay=1&muted=1&loop=1&background=1`;
          }
          if (!src) return;
          const iframe = document.createElement('iframe');
          iframe.className = 'password__media-frame';
          iframe.src = src;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.setAttribute('tabindex', '-1');
          iframe.setAttribute('aria-hidden', 'true');
          this.appendChild(iframe);
        }
      }
    );
  }

  // Countdown
  (function () {
    const el = document.querySelector('[data-countdown]');
    if (!el) return;
    const target = new Date((el.dataset.date || '').replace(' ', 'T')).getTime();
    if (isNaN(target)) return;
    const out = {
      days: el.querySelector('[data-days]'),
      hours: el.querySelector('[data-hours]'),
      minutes: el.querySelector('[data-minutes]'),
      seconds: el.querySelector('[data-seconds]')
    };
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) {
        out.days.textContent = out.hours.textContent = out.minutes.textContent = out.seconds.textContent = '00';
        clearInterval(timer);
        return;
      }
      const s = Math.floor(diff / 1000);
      out.days.textContent = pad(Math.floor(s / 86400));
      out.hours.textContent = pad(Math.floor((s % 86400) / 3600));
      out.minutes.textContent = pad(Math.floor((s % 3600) / 60));
      out.seconds.textContent = pad(s % 60);
    };
    tick();
    el.hidden = false;
    const timer = setInterval(tick, 1000);
  })();

  // Password dialog
  (function () {
    const dialog = document.querySelector('[data-pw-dialog]');
    if (!dialog) return;
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-pw-open]')) dialog.showModal();
      else if (e.target.closest('[data-pw-close]') || e.target === dialog) dialog.close();
    });
    // Re-open automatically when the password was wrong
    if (dialog.querySelector('.password__errors')) dialog.showModal();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-custom-order"]) return;
  try {
    
  if (!customElements.get('variant-picker')) {
    customElements.define(
      'variant-picker',
      class VariantPicker extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(
            this.querySelector('[data-variants]').textContent
          );
          this.form = this.closest('form');
          this.section = this.closest('.shopify-section') || document;
          this.addEventListener('change', () => this.update());
        }

        selectedOptions() {
          return Array.from(this.querySelectorAll('fieldset')).map(
            (fieldset) => {
              const checked = fieldset.querySelector('input:checked');
              return checked ? checked.value : null;
            }
          );
        }

        update() {
          const selected = this.selectedOptions();
          const variant = this.variants.find((v) =>
            v.options.every((option, index) => option === selected[index])
          );

          this.querySelectorAll('fieldset').forEach((fieldset) => {
            const label = fieldset.querySelector('[data-option-selected]');
            const checked = fieldset.querySelector('input:checked');
            if (label && checked) label.textContent = checked.value;
          });
          const idInput = this.form.querySelector('input[name="id"]');
          const button = this.form.querySelector('[data-add-to-cart]');
          const price = this.section.querySelector('[data-price]');
          const priceCurrent = this.section.querySelector('[data-price-current]');
          const priceCompare = this.section.querySelector('[data-price-compare]');

          if (!variant) {
            button.disabled = true;
            const lbl = button.querySelector('[data-add-label]');
            if (lbl) lbl.textContent = button.dataset.labelUnavailable;
            return;
          }

          idInput.value = variant.id;
          const stockMax = variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny'
            ? variant.inventory_quantity : null;
          if (stockMax === null) delete idInput.dataset.stockMax;
          else idInput.dataset.stockMax = stockMax;
          const quantityInput = this.form.querySelector('input[name="quantity"]');
          if (quantityInput) {
            if (stockMax === null) quantityInput.removeAttribute('max');
            else quantityInput.max = stockMax;
            if (stockMax !== null && Number(quantityInput.value) > stockMax) quantityInput.value = Math.max(1, stockMax);
          }
          priceCurrent.textContent = variant.price;
          if (variant.compare_at_price) {
            priceCompare.textContent = variant.compare_at_price;
            priceCompare.hidden = false;
            price.classList.add('price--on-sale');
          } else {
            priceCompare.hidden = true;
            price.classList.remove('price--on-sale');
          }

          button.disabled = false;
          const stockIn = this.section.querySelector('[data-stock-in]');
          const stockOut = this.section.querySelector('[data-stock-out]');
          const stockLow = this.section.querySelector('[data-stock-low]');
          const threshold = stockLow ? Number(stockLow.dataset.threshold) : 0;
          const qty = variant.inventory_quantity;
          const isLow =
            variant.available &&
            variant.inventory_management &&
            qty > 0 &&
            qty <= threshold;
          if (stockLow) {
            stockLow.hidden = !isLow;
            const text = stockLow.querySelector('[data-stock-low-text]');
            if (text && isLow) {
              text.textContent = stockLow.dataset.template.split('%count%').join(qty);
            }
          }
          if (stockIn) stockIn.hidden = !variant.available || isLow;
          if (stockOut) stockOut.hidden = variant.available;
          const addLabel = button.querySelector('[data-add-label]');
          const addPrice = button.querySelector('[data-add-price]');
          if (addLabel) {
            addLabel.textContent = variant.available
              ? button.dataset.labelAdd
              : button.dataset.labelSoldOut;
          }
          if (addPrice) {
            addPrice.textContent = variant.price;
            addPrice.hidden = !variant.available;
          }
          const addSep = button.querySelector('[data-add-sep]');
          if (addSep) addSep.hidden = !variant.available;
          button.classList.toggle('button--secondary', !variant.available);
          button.classList.toggle('product__add--notify', !variant.available);

          const sku = this.section.querySelector('[data-sku]');
          if (sku && variant.sku != null) sku.textContent = variant.sku;

          const enquiry = this.section.querySelector('[data-availability-request]');
          if (enquiry) enquiry.value = `Availability enquiry: ${enquiry.dataset.productTitle} — ${variant.options.join(' / ')} (${variant.id})`;
          const notifyImg = this.section.querySelector('[data-notify-image]');
          if (notifyImg && variant.image) notifyImg.src = variant.image;

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }
    );
  }

  if (!window.goldProductShareInit) {
    window.goldProductShareInit = true;
    document.addEventListener('click', async (event) => {
      // Share
      const shareBtn = event.target.closest('[data-share-url]');
      if (shareBtn) {
        const data = { title: shareBtn.dataset.shareTitle, url: shareBtn.dataset.shareUrl };
        if (navigator.share) {
          try { await navigator.share(data); } catch (e) {}
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(data.url);
          shareBtn.classList.add('is-copied');
          setTimeout(() => shareBtn.classList.remove('is-copied'), 1500);
        }
        return;
      }

      // Out-of-stock CTA opens the notify popup instead of submitting
      const addBtn = event.target.closest('[data-add-to-cart]');
      if (addBtn && addBtn.classList.contains('product__add--notify')) {
        event.preventDefault();
        const dialog = (addBtn.closest('.shopify-section') || document).querySelector('[data-notify-dialog]');
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }

      // Close the notify popup (close button or backdrop click)
      if (event.target.closest('[data-notify-close]')) {
        event.target.closest('dialog').close();
        return;
      }
      const openDialog = document.querySelector('.notify-dialog[open]');
      if (openDialog && event.target === openDialog) openDialog.close();
    });

    // Re-open the popup after a successful submit (page reloads)
    document.querySelectorAll('[data-notify-success]').forEach((el) => {
      const dialog = el.closest('[data-notify-dialog]');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-neon"]) return;
  try {
    
  if (!customElements.get('variant-picker')) {
    customElements.define(
      'variant-picker',
      class VariantPicker extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(
            this.querySelector('[data-variants]').textContent
          );
          this.form = this.closest('form');
          this.section = this.closest('.shopify-section') || document;
          this.addEventListener('change', () => this.update());
        }

        selectedOptions() {
          return Array.from(this.querySelectorAll('fieldset')).map(
            (fieldset) => {
              const checked = fieldset.querySelector('input:checked');
              return checked ? checked.value : null;
            }
          );
        }

        update() {
          const selected = this.selectedOptions();
          const variant = this.variants.find((v) =>
            v.options.every((option, index) => option === selected[index])
          );

          this.querySelectorAll('fieldset').forEach((fieldset) => {
            const label = fieldset.querySelector('[data-option-selected]');
            const checked = fieldset.querySelector('input:checked');
            if (label && checked) label.textContent = checked.value;
          });
          const idInput = this.form.querySelector('input[name="id"]');
          const button = this.form.querySelector('[data-add-to-cart]');
          const price = this.section.querySelector('[data-price]');
          const priceCurrent = this.section.querySelector('[data-price-current]');
          const priceCompare = this.section.querySelector('[data-price-compare]');

          if (!variant) {
            button.disabled = true;
            const lbl = button.querySelector('[data-add-label]');
            if (lbl) lbl.textContent = button.dataset.labelUnavailable;
            return;
          }

          idInput.value = variant.id;
          priceCurrent.textContent = variant.price;
          if (variant.compare_at_price) {
            priceCompare.textContent = variant.compare_at_price;
            priceCompare.hidden = false;
            price.classList.add('price--on-sale');
          } else {
            priceCompare.hidden = true;
            price.classList.remove('price--on-sale');
          }

          button.disabled = false;
          const stockIn = this.section.querySelector('[data-stock-in]');
          const stockOut = this.section.querySelector('[data-stock-out]');
          const stockLow = this.section.querySelector('[data-stock-low]');
          const threshold = stockLow ? Number(stockLow.dataset.threshold) : 0;
          const qty = variant.inventory_quantity;
          const isLow =
            variant.available &&
            variant.inventory_management &&
            qty > 0 &&
            qty <= threshold;
          if (stockLow) {
            stockLow.hidden = !isLow;
            const text = stockLow.querySelector('[data-stock-low-text]');
            if (text && isLow) {
              text.textContent = stockLow.dataset.template.split('%count%').join(qty);
            }
          }
          if (stockIn) stockIn.hidden = !variant.available || isLow;
          if (stockOut) stockOut.hidden = variant.available;
          const addLabel = button.querySelector('[data-add-label]');
          const addPrice = button.querySelector('[data-add-price]');
          if (addLabel) {
            addLabel.textContent = variant.available
              ? button.dataset.labelAdd
              : button.dataset.labelSoldOut;
          }
          if (addPrice) {
            addPrice.textContent = variant.price;
            addPrice.hidden = !variant.available;
          }
          const addSep = button.querySelector('[data-add-sep]');
          if (addSep) addSep.hidden = !variant.available;
          button.classList.toggle('button--secondary', !variant.available);
          button.classList.toggle('product__add--notify', !variant.available);

          const sku = this.section.querySelector('[data-sku]');
          if (sku && variant.sku != null) sku.textContent = variant.sku;

          const notifyImg = this.section.querySelector('[data-notify-image]');
          if (notifyImg && variant.image) notifyImg.src = variant.image;

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }
    );
  }

  if (!window.goldProductShareInit) {
    window.goldProductShareInit = true;
    document.addEventListener('click', async (event) => {
      // Share
      const shareBtn = event.target.closest('[data-share-url]');
      if (shareBtn) {
        const data = { title: shareBtn.dataset.shareTitle, url: shareBtn.dataset.shareUrl };
        if (navigator.share) {
          try { await navigator.share(data); } catch (e) {}
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(data.url);
          shareBtn.classList.add('is-copied');
          setTimeout(() => shareBtn.classList.remove('is-copied'), 1500);
        }
        return;
      }

      // Out-of-stock CTA opens the notify popup instead of submitting
      const addBtn = event.target.closest('[data-add-to-cart]');
      if (addBtn && addBtn.classList.contains('product__add--notify')) {
        event.preventDefault();
        const dialog = (addBtn.closest('.shopify-section') || document).querySelector('[data-notify-dialog]');
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }

      // Close the notify popup (close button or backdrop click)
      if (event.target.closest('[data-notify-close]')) {
        event.target.closest('dialog').close();
        return;
      }
      const openDialog = document.querySelector('.notify-dialog[open]');
      if (openDialog && event.target === openDialog) openDialog.close();
    });

    // Re-open the popup after a successful submit (page reloads)
    document.querySelectorAll('[data-notify-success]').forEach((el) => {
      const dialog = el.closest('[data-notify-dialog]');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('variant-picker')) {
    customElements.define(
      'variant-picker',
      class VariantPicker extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(
            this.querySelector('[data-variants]').textContent
          );
          this.form = this.closest('form');
          this.section = this.closest('.shopify-section') || document;
          this.addEventListener('change', () => this.update());
        }

        selectedOptions() {
          return Array.from(this.querySelectorAll('fieldset')).map(
            (fieldset) => {
              const checked = fieldset.querySelector('input:checked');
              return checked ? checked.value : null;
            }
          );
        }

        update() {
          const selected = this.selectedOptions();
          const variant = this.variants.find((v) =>
            v.options.every((option, index) => option === selected[index])
          );

          this.querySelectorAll('fieldset').forEach((fieldset) => {
            const label = fieldset.querySelector('[data-option-selected]');
            const checked = fieldset.querySelector('input:checked');
            if (label && checked) label.textContent = checked.value;
          });
          const idInput = this.form.querySelector('input[name="id"]');
          const button = this.form.querySelector('[data-add-to-cart]');
          const price = this.section.querySelector('[data-price]');
          const priceCurrent = this.section.querySelector('[data-price-current]');
          const priceCompare = this.section.querySelector('[data-price-compare]');

          if (!variant) {
            button.disabled = true;
            const lbl = button.querySelector('[data-add-label]');
            if (lbl) lbl.textContent = button.dataset.labelUnavailable;
            return;
          }

          idInput.value = variant.id;
          const stockMax = variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny'
            ? variant.inventory_quantity : null;
          if (stockMax === null) delete idInput.dataset.stockMax;
          else idInput.dataset.stockMax = stockMax;
          const quantityInput = this.form.querySelector('input[name="quantity"]');
          if (quantityInput) {
            if (stockMax === null) quantityInput.removeAttribute('max');
            else quantityInput.max = stockMax;
            if (stockMax !== null && Number(quantityInput.value) > stockMax) quantityInput.value = Math.max(1, stockMax);
          }
          priceCurrent.textContent = variant.price;
          if (variant.compare_at_price) {
            priceCompare.textContent = variant.compare_at_price;
            priceCompare.hidden = false;
            price.classList.add('price--on-sale');
          } else {
            priceCompare.hidden = true;
            price.classList.remove('price--on-sale');
          }

          button.disabled = false;
          const stockIn = this.section.querySelector('[data-stock-in]');
          const stockOut = this.section.querySelector('[data-stock-out]');
          const stockLow = this.section.querySelector('[data-stock-low]');
          const threshold = stockLow ? Number(stockLow.dataset.threshold) : 0;
          const qty = variant.inventory_quantity;
          const isLow =
            variant.available &&
            variant.inventory_management &&
            qty > 0 &&
            qty <= threshold;
          if (stockLow) {
            stockLow.hidden = !isLow;
            const text = stockLow.querySelector('[data-stock-low-text]');
            if (text && isLow) {
              text.textContent = stockLow.dataset.template.split('%count%').join(qty);
            }
          }
          if (stockIn) stockIn.hidden = !variant.available || isLow;
          if (stockOut) stockOut.hidden = variant.available;
          const addLabel = button.querySelector('[data-add-label]');
          const addPrice = button.querySelector('[data-add-price]');
          if (addLabel) {
            addLabel.textContent = variant.available
              ? button.dataset.labelAdd
              : button.dataset.labelSoldOut;
          }
          if (addPrice) {
            addPrice.textContent = variant.price;
            addPrice.hidden = !variant.available;
          }
          const addSep = button.querySelector('[data-add-sep]');
          if (addSep) addSep.hidden = !variant.available;
          button.classList.toggle('button--secondary', !variant.available);
          button.classList.toggle('product__add--notify', !variant.available);

          const sku = this.section.querySelector('[data-sku]');
          if (sku && variant.sku != null) sku.textContent = variant.sku;

          const enquiry = this.section.querySelector('[data-availability-request]');
          if (enquiry) enquiry.value = `Availability enquiry: ${enquiry.dataset.productTitle} — ${variant.options.join(' / ')} (${variant.id})`;
          const notifyImg = this.section.querySelector('[data-notify-image]');
          if (notifyImg && variant.image) notifyImg.src = variant.image;

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }
    );
  }

  if (!window.goldProductShareInit) {
    window.goldProductShareInit = true;
    document.addEventListener('click', async (event) => {
      // Share
      const shareBtn = event.target.closest('[data-share-url]');
      if (shareBtn) {
        const data = { title: shareBtn.dataset.shareTitle, url: shareBtn.dataset.shareUrl };
        if (navigator.share) {
          try { await navigator.share(data); } catch (e) {}
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(data.url);
          shareBtn.classList.add('is-copied');
          setTimeout(() => shareBtn.classList.remove('is-copied'), 1500);
        }
        return;
      }

      // Out-of-stock CTA opens the notify popup instead of submitting
      const addBtn = event.target.closest('[data-add-to-cart]');
      if (addBtn && addBtn.classList.contains('product__add--notify')) {
        event.preventDefault();
        const dialog = (addBtn.closest('.shopify-section') || document).querySelector('[data-notify-dialog]');
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }

      // Close the notify popup (close button or backdrop click)
      if (event.target.closest('[data-notify-close]')) {
        event.target.closest('dialog').close();
        return;
      }
      const openDialog = document.querySelector('.notify-dialog[open]');
      if (openDialog && event.target === openDialog) openDialog.close();
    });

    // Re-open the popup after a successful submit (page reloads)
    document.querySelectorAll('[data-notify-success]').forEach((el) => {
      const dialog = el.closest('[data-notify-dialog]');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!customElements.get('related-products')) {
    customElements.define(
      'related-products',
      class RelatedProducts extends HTMLElement {
        connectedCallback() {
          const observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              observer.disconnect();
              this.load();
            },
            { rootMargin: '400px' }
          );
          observer.observe(this);
        }

        async load() {
          const params = new URLSearchParams({
            product_id: this.dataset.productId,
            limit: this.dataset.limit,
            section_id: 'related-products',
            intent: 'related',
          });
          const response = await fetch(`${this.dataset.url}?${params}`);
          const html = await response.text();
          const incoming = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-recommendations]');
          if (incoming) {
            this.querySelector('[data-recommendations]').replaceWith(incoming);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-badge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-badge][data-rotate]').forEach(function (badge) {
      if (badge.dataset.badgeInit) return;
      badge.dataset.badgeInit = 'true';
      var mark = badge.querySelector('.badge__mark');
      var speed = Number(badge.dataset.rotate);
      var ticking = false;
      function update() {
        ticking = false;
        mark.style.setProperty('--badge-rot', (window.scrollY * speed / 100).toFixed(2) + 'deg');
      }
      window.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slide-show')) {
    customElements.define(
      'slide-show',
      class SlideShow extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.dots = Array.from(this.querySelectorAll('.slideshow__dot'));
          this.count = this.track.children.length;
          this.index = 0;

          this.querySelector('[data-prev]')?.addEventListener('click', () =>
            this.goTo(this.index - 1)
          );
          this.querySelector('[data-next]')?.addEventListener('click', () =>
            this.goTo(this.index + 1)
          );
          this.dots.forEach((dot) =>
            dot.addEventListener('click', () =>
              this.goTo(Number(dot.dataset.index))
            )
          );

          this.track.addEventListener(
            'scroll',
            () => {
              clearTimeout(this.scrollTimer);
              this.scrollTimer = setTimeout(() => {
                this.index = Math.round(
                  this.track.scrollLeft / this.track.clientWidth
                );
                this.markActive();
              }, 80);
            },
            { passive: true }
          );

          const speed = Number(this.dataset.autoplay);
          const reducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;
          if (speed && this.count > 1 && !reducedMotion) {
            this.startAutoplay(speed * 1000);
            this.addEventListener('pointerenter', () => this.stopAutoplay());
            this.addEventListener('pointerleave', () =>
              this.startAutoplay(speed * 1000)
            );
            this.addEventListener('focusin', () => this.stopAutoplay());
            this.addEventListener('focusout', () =>
              this.startAutoplay(speed * 1000)
            );
          }
        }

        disconnectedCallback() {
          this.stopAutoplay();
        }

        startAutoplay(ms) {
          this.stopAutoplay();
          this.timer = setInterval(() => this.goTo(this.index + 1), ms);
        }

        stopAutoplay() {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
        }

        goTo(index) {
          this.index = (index + this.count) % this.count;
          this.track.scrollTo({
            left: this.index * this.track.clientWidth,
            behavior: 'smooth',
          });
          this.markActive();
        }

        markActive() {
          this.dots.forEach((dot, i) =>
            dot.classList.toggle('is-active', i === this.index)
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-strip"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-stats]').forEach(function (section) {
    if (section.dataset.statsInit) return;
    section.dataset.statsInit = 'true';

    if (!('IntersectionObserver' in window)) return;
    section.classList.add('stats--armed');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('stats--in');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-slider')) {
    customElements.define(
      'testimonial-slider',
      class TestimonialSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-testimonials-track]');
          const prev = this.querySelector('[data-testimonials-prev]');
          const next = this.querySelector('[data-testimonials-next]');
          if (!this.track || !prev) return;
          const step = () => {
            const card = this.track.querySelector('.testimonials__card');
            if (!card) return this.track.clientWidth;
            const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
            return card.getBoundingClientRect().width + gap;
          };
          // Chrome cancels smooth programmatic scrolls on snap containers,
          // so disable snapping during the animation; if the smooth scroll
          // doesn't run at all (some environments), jump instantly.
          const glide = (dx) => {
            const t = this.track;
            const from = t.scrollLeft;
            t.style.scrollSnapType = 'none';
            t.scrollBy({ left: dx, behavior: 'smooth' });
            clearTimeout(this.fallbackTimer);
            clearTimeout(this.snapTimer);
            this.fallbackTimer = setTimeout(() => {
              if (Math.abs(t.scrollLeft - from) < 2) t.scrollBy({ left: dx, behavior: 'auto' });
            }, 300);
            this.snapTimer = setTimeout(() => {
              t.style.scrollSnapType = '';
            }, 800);
          };
          prev.addEventListener('click', () => glide(-step()));
          next.addEventListener('click', () => glide(step()));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-facade')) {
    customElements.define(
      'video-facade',
      class VideoFacade extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', () => this.activate(), { once: true });
        }

        embedUrl() {
          const url = this.dataset.url;
          const youtube = url.match(
            /(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/
          );
          if (youtube) {
            return `https://www.youtube-nocookie.com/embed/${youtube[1]}?autoplay=1`;
          }
          const vimeo = url.match(/vimeo\.com\/(\d+)/);
          if (vimeo) {
            return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1`;
          }
          return null;
        }

        activate() {
          const src = this.embedUrl();
          if (!src) return;
          const iframe = document.createElement('iframe');
          iframe.className = 'video-section__frame';
          iframe.src = src;
          iframe.allow =
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          this.replaceChildren(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
